import React from 'react'
import UpsaleGroupOption from './upsale-group-option'
import ProductStore from '../../stores/product-store'
import UpsalePreviewImages from './upsale-preview-images'
import UpsaleGroupPrintsTotal from './upsale-group-prints-total'
import UpsaleGroupTotal from './upsale-group-total'
import Config from '../../config'
import {Link} from 'react-router-component'
import createReactClass from 'create-react-class'


var UpsaleGroupPaperTypes = createReactClass({

	render: function () {

		var upsaleOptions = this.props.upsaleOptions;

		var upsaleOptionComponentList = [];
	      for (var option in upsaleOptions) {
	        if (upsaleOptions.hasOwnProperty(option)) {
	          if (upsaleOptions[option].visible && upsaleOptions[option].type === "paperType") {
	            upsaleOptionComponentList.push(<UpsaleGroupOption inputType="radio" option={upsaleOptions[option]} optionName={option} quantity={this.props.quantity} itemList={this.props.itemList} key={this.props.productId + '_' + option} name={this.props.productId + '_' + option} productId={this.props.productId} />);
	          }
	        }
	      }

		return (
			<div>
				<span className="ope-upsale__group__optionList-header">{_('Paper')}:</span>
				<ul className="ope-upsale__group__optionList">
		            {upsaleOptionComponentList}
		        </ul>
	        </div>
		);
	}
});

export default UpsaleGroupPaperTypes;
